import React, { useEffect, useState } from "react";
import { ArrowBigDownDash } from "lucide-react";
import { getAppointmentById } from "../../core/api/appointment";
import { useParams } from "react-router-dom";

const AppointmentDetails = () => {
    const [appointment, setAppointment] = useState({});
    const params = useParams();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAppointment = async () => {
            try {
                setLoading(true);
                const appointmentId = params.id;
                const res = await getAppointmentById(appointmentId);
                setAppointment(res?.data);
                console.log(res, "res");
            } catch (error) {
                console.error(error);
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        fetchAppointment();
    }, [params.id]);


    const downloadFile = (url) => {
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.setAttribute('download', url);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    if (loading) {
        return (
            <div className="page-wrapper">
                <div className="content">
                    <div className="card" >
                        <div className="card-body">
                            <div className="d-flex justify-content-center align-items-center gap-2" style={{ height: 200 }}>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                Loading...
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    if (error) {
        return (
            <div className="page-wrapper">
                <div className="content">
                    <div className="card">
                        <div className="card-body">
                            <div>
                                Error occurred while fetching appointment details
                            </div>;
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="page-header">
                    <div className="page-title">
                        <h4>Appointment Details</h4>
                        <h6>Full details of appointment</h6>
                    </div>
                    <button 
                    className="btn btn-submit d-flex align-items-center justify-content-center w-fit"
                     style={{ width: 120 }} >
                        Send Worklist
                    </button>
                </div>
                <div className="row">
                    <div className="col-lg-6 col-sm-12" style={{ height: "fit-content" }}>
                        <div className="card">
                            <div className="card-body">
                                <div className="productdetails">
                                    <ul className="product-bar">
                                        <li>
                                            <h4>Appointment ID</h4>
                                            <h6>#{appointment?.id}</h6>
                                        </li>
                                        <li>
                                            <h4>Date</h4>
                                            <h6>{new Date(appointment?.appointmentDate).toLocaleDateString()}</h6>
                                        </li>
                                        <li>
                                            <h4>Time</h4>
                                            <h6>{appointment?.appointmentTime || "-"}</h6>
                                        </li>
                                        <li>
                                            <h4>Status</h4>
                                            <h6>{appointment?.status || "-"}</h6>
                                        </li>
                                        <li>
                                            <h4>Notes</h4>
                                            <h6>{appointment?.notes || "-"}</h6>
                                        </li>
                                        <li>
                                            <h4>Created At</h4>
                                            <h6>{new Date(appointment?.createdAt)?.toLocaleString()}</h6>
                                        </li>
                                        <li>
                                            <h4>Updated At</h4>
                                            <h6>{new Date(appointment?.updatedAt).toLocaleString()}</h6>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="card mt-4 pb-3">
                            <div className="card-body">
                                <div className="productdetails">
                                    <h4 className="mb-2 fw-medium">Consulting Doctor</h4>
                                    {
                                        appointment?.employee &&
                                        <ul className="product-bar">
                                            <li>
                                                <h4>Healthcare Provider</h4>
                                                <h6>{`${appointment?.employee?.firstName || ''} ${appointment?.employee?.surname || ''}`}</h6>
                                            </li>
                                            <li>
                                                <h4>Provider Email</h4>
                                                <h6>{appointment?.employee?.email || "-"}</h6>
                                            </li>
                                            <li>
                                                <h4>Provider Phone</h4>
                                                <h6>{appointment?.employee?.phone || "-"}</h6>
                                            </li>
                                        </ul>
                                    }
                                    {
                                        !appointment?.employee &&
                                        <div>
                                            <h6>No consulting doctor assigned</h6>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="card pb-0" style={{ marginTop: 30 }}>
                            <div className="card-body">
                                <div className="productdetails">
                                    <h4 className="mb-2 fw-medium">Services</h4>
                                    <div className="table-responsive">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Service Name</th>
                                                    <th>Type of Exam</th>
                                                    <th>Amount</th>
                                                    <th>Payment Method</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {appointment?.services?.map((service, index) => (
                                                    <tr key={service?.id}>
                                                        <td>{service?.name || "-"}</td>
                                                        <td>{service?.typeOfExam || "-"}</td>
                                                        <td>P {service?.amount || "-"}</td>
                                                        <td>{service?.paymentMethod || "-"}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-12" style={{ height: "fit-content" }}>
                        <div className="card">
                            <div className="card-body">
                                <div className="productdetails">
                                    <h4 className="mb-2 fw-medium">Patient Information</h4>
                                    {
                                        appointment?.patient &&
                                        <ul className="product-bar">
                                            <li>
                                                <h4>Patient Name</h4>
                                                <h6>{`${appointment?.patient?.title || ''} ${appointment?.patient?.firstName || ''} ${appointment?.patient?.surname || ''}`}</h6>
                                            </li>
                                            <li>
                                                <h4>ID/Passport</h4>
                                                <h6>{appointment?.patient?.idOrPassport || "-"}</h6>
                                            </li>
                                            <li>
                                                <h4>Patient Email</h4>
                                                <h6>{appointment?.patient?.email || "-"}</h6>
                                            </li>
                                            <li>
                                                <h4>Patient Phone</h4>
                                                <h6>{appointment?.patient?.phoneNumber || "-"}</h6>
                                            </li>
                                            <li>
                                                <h4>Alternate Number</h4>
                                                <h6>{appointment?.patient?.alternateNumber || "-"}</h6>
                                            </li>
                                            <li>
                                                <h4>Next of Kin</h4>
                                                <h6>{appointment?.patient?.nextOfKin || "-"}</h6>
                                            </li>
                                            <li>
                                                <h4>Physical Address</h4>
                                                <h6>{appointment?.patient?.physicalAddress || "-"}</h6>
                                            </li>
                                            <li>
                                                <h4>Postal Address</h4>
                                                <h6>{appointment?.patient?.postalAddress || "-"}</h6>
                                            </li>
                                            <li>
                                                <h4>Date of Birth</h4>
                                                <h6>{appointment?.patient?.dob ? new Date(appointment?.patient?.dob).toLocaleDateString() : "-"}</h6>
                                            </li>
                                            <li>
                                                <h4>Gender</h4>
                                                <h6>{appointment?.patient?.gender || "-"}</h6>
                                            </li>
                                            <li>
                                                <h4>Payment Status</h4>
                                                <h6>{appointment?.paymentStatus || "-"}</h6>
                                            </li>
                                            <li>
                                                <h4>Created At</h4>
                                                <h6>{new Date(appointment?.patient?.createdAt).toLocaleString()}</h6>
                                            </li>
                                        </ul>
                                    }
                                    {
                                        !appointment?.patient &&
                                        <div>
                                            <h6>No patient information available</h6>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-body">
                                <div className="slider-product-details">
                                    {
                                        (appointment?.bloodTests?.length > 0 || appointment?.referralForms?.length > 0) &&
                                        <div className="mb-1">
                                            <h4 className="fw-medium">Attachments</h4>
                                            <div className="d-flex gap-1 align-items-center">
                                                {appointment?.bloodTests?.map((file, index) => (
                                                    <div style={{ marginTop: '10px' }} key={index} onClick={() => downloadFile(file?.url)}>
                                                        <div className="image-upload d-flex justify-content-center align-items-center" role="button" style={{ height: 100, marginBottom: 10, borderRadius: 10, width: 140 }}>
                                                            <div className="d-flex flex-column justify-content-center align-items-center">
                                                                <ArrowBigDownDash color="#999999" size={25} className="mb-1" />
                                                                <p className="mb-0" style={{ fontSize: 12, fontWeight: "600" }}>Lab Results</p>
                                                                <p style={{ fontSize: 10, padding: "0px 10px", fontStyle: 'italic', wordBreak: 'break-all', textAlign: 'center' }}>{file?.name}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                                {appointment?.referralForms?.map((file, index) => (
                                                    <div style={{ marginTop: '10px' }} key={index} onClick={() => downloadFile(file?.url)}>
                                                        <div className="image-upload d-flex justify-content-center align-items-center" role="button" style={{ height: 100, marginBottom: 10, borderRadius: 10, width: 140 }}>
                                                            <div className="d-flex flex-column justify-content-center align-items-center">
                                                                <ArrowBigDownDash color="#999999" size={25} className="mb-1" />
                                                                <p className="mb-0" style={{ fontSize: 12, fontWeight: "600" }}>Referral</p>
                                                                <p style={{ fontSize: 10, padding: "0px 10px", fontStyle: 'italic', wordBreak: 'break-all', textAlign: 'center' }}>{file?.name}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    }
                                    {
                                        appointment?.bloodTests?.length === 0 && appointment?.referralForms?.length === 0 &&
                                        <div>
                                            <h6>No attachments available</h6>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AppointmentDetails;